//this creates an app-icon which when clicked will open a popover which is placed in the middle of the screen (so opoover is not attached to triggering button)
angular.module('cfn').directive('cfnWizardAppIcon', [
  '$rootScope',
  '$log',
  '$dialog',
  function($rootScope, $log, $dialog) {
    return {
      restrict: 'E',
      scope: {
        caption: '@',
        name: '@',
        wizardcontroller: '@',
        wizardtemplate: '@',
        nonauthorized: '@',
        onfinish: '&',
        color: '@',
        category: '@',
        icon: '@',
        iconPath: '@',
        fnIcon: '@',
        modalClass: '@'
      },
      transclude: true,
      replace: false,
      template: `
           <app-icon 
            name="{{ name }}" 
            title="{{ caption }}" 
            caption="{{ caption }}" 
            nonauthorized="{{ nonauthorized }}" 
            color="{{ color }}" 
            category="{{ category }}" 
            icon-path="{{ iconPath }}"
            fn-icon="{{ fnIcon }}"
          ></app-icon>`,

      // TODO: inject
      link: function($scope, element, attrs) {
        var modalClass = $scope.modalClass
          ? $scope.modalClass + ' wizard-modal'
          : 'wizard-modal';

        element.bind('click', function() {
          $dialog
            .dialog({
              backdropClick: false,
              dialogClass: modalClass
            })
            // TODO: find out what comes as `$scope.wizardtemplate`
            .open($scope.wizardtemplate, $scope.wizardcontroller)
            .then(function(exitResult) {
              if (exitResult && exitResult.action == 'success') {
                if ($scope.onfinish) {
                  $scope.onfinish();
                }
              }
            });
        });
      }
    };
  }
]);

/*
 * A single wizard step symbol.
 * index: nth element of the wizard (number starting form 1)
 * text: text of wizard step
 * ready: is this step ready? (boolean)
 * sample: <cfn-wizard-step number="1" text="Erster Schritt"></cfn-wizard-step> <cfn-wizard-step number="2" text="Erster Schritt"></cfn-wizard-step>
 */
angular.module('cfn').directive('cfnWizardStep', [
  '$rootScope',
  '$log',
  '$dialog',
  '$timeout',
  function($rootScope, $log, $dialog, $timeout) {
    return {
      restrict: 'E',
      scope: {
        index: '@',
        text: '@',
        ready: '@' // Note: ready is represented as a string!
      },
      replace: true,
      template:
        '<div class="step {{ready==\'true\' ? \'step-ready\':\'step-disabled\'}}">	<span class="stepNumber" style="position:relative;">' +
        '		{{index}}' +
        '		<div class="stepLine" ng-if="index>1"></div>' +
        '	</span>' +
        '	<span class="stepContent">{{text}}</span></div>',

      link: function($scope, element, attrs) {}
    };
  }
]);

/*
 * Complete wizard line.
 * see sample usage in fieldImportWizard.html.
 * This is the complete solution if the problem is exactly the same as fieldImportWizard. If not use cfn-wizard-step for each step between <center>  (...) <div class=\"clearfix\"></div></center>
 */
angular.module('cfn').directive('cfnWizardStepLine', [
  '$rootScope',
  '$log',
  '$dialog',
  '$timeout',
  function($rootScope, $log, $dialog, $timeout) {
    return {
      restrict: 'E',
      scope: {
        steps: '=',
        currentSteps: '=',
        stepsText: '=',
        stepClick: '='
      },
      template:
        '<center>' +
        "		<cfn-wizard-step ng-repeat=\"step in steps\" ready='{{currentSteps[step]}}' ng-click='currentSteps[step]?stepClick(step):void(0)' index='{{$index+1}}' text='{{stepsText[step]}}'></cfn-wizard-step>" +
        '<div class="clearfix"></div>' +
        '</center>',
      link: function($scope, element, attrs) {}
    };
  }
]);

//this creates a button which when clicked opens a popover which is placed in the middle of the screen (so opoover is not attached to triggering button)
angular.module('cfn').directive('cfnWizardButton', [
  '$rootScope',
  '$log',
  '$dialog',
  '$timeout',
  function($rootScope, $log, $dialog, $timeout) {
    return {
      restrict: 'E',
      scope: {
        img: '@',
        caption: '@',
        corecontroller: '=',
        wizardcontroller: '@',
        wizardtemplate: '@',
        onfinish: '&'
      },

      replace: true,
      template:
        '<button class="btn" ng-click="showPopover()"><img ng-if="img" ng-src="{{img}}"/><span class="hideIfRight2">{{caption}}</span></button>',

      link: function($scope, element, attrs) {
        $scope.showPopover = function() {
          var modalInstance = $dialog
            .dialog({
              backdropClick: false,
              dialogClass: 'wizard-modal',
              resolve: {
                coreController: function() {
                  return $scope.corecontroller;
                }
              }
              // TODO: find out what comes as `$scope.wizardtemplate`
            })
            .open($scope.wizardtemplate, $scope.wizardcontroller)
            .then(function(exitResult) {
              if (exitResult && exitResult.action == 'success') {
                if ($scope.onfinish) $scope.onfinish();
              }
            });
        };
      }
    };
  }
]);
